// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { inject, injectable } from "inversify";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Types } from "../../../ioc/types";
import type { IHttpService } from "../../http/models/IHttpService";
import { IdpLoginAuthServiceRequest, IdpLoginAuthServiceResponse, IIdpAuthService } from "../models/IdpAuthService";

@injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class IdpAuthService implements IIdpAuthService{

    @inject(Types.IHttpService)
    private httpInstance!: IHttpService;

    public async login(data: IdpLoginAuthServiceRequest): Promise<IdpLoginAuthServiceResponse> {
      return this.httpInstance.post<IdpLoginAuthServiceResponse>("/idp/auth/login", data);
    }
}
